import { TrackByFunction } from '@angular/core';

/**
 * Tracks items in *ngFor structural directives to avoid multiple renders of all the elements inside the directive
 * on changes
 *
 * @param key
 * @param concatenationString
 * */
export const trackByKey = <T, K extends keyof T>(key: K, concatenationString?: string): TrackByFunction<T> => {
  return (_: number, item: T) => {
    if (!concatenationString) {
      return item[key];
    }
    return item[key] + concatenationString;
  };
};

/**
 * Tracks items in *ngFor structural directives in which the return item could be a date
 * */
export const trackByDate =
  <T, K extends keyof T>(key: K): TrackByFunction<T> =>
  (_: number, item: T) => {
    const date = item[key];
    return date instanceof Date ? date.getTime() : date;
  };

/**
 * Tracks items in *ngFor structural directives with items that do not have properties that can be tracked.
 *
 * Useful for items which are always in the same order and not destroyed or created.
 * */
export const trackByIndex = (index: number): number => index;

/**
 * Tracks items in *ngFor structural directives directly with the received value
 *
 * Useful for items which are contained in arrays of primitive types
 * */
export const trackByValue = <T>(_: number, item: T): T => item;
